<template>
  <div class="news-cell" v-on:click="onClick(item)">
    <div class="news-cell-head">
      <van-grid
        class="news-cell-imgs"
        :border="false"
        :gutter="5"
        :column-num="3"
      >
        <van-grid-item
          class="news-cell-img"
          v-for="(img, index) in item.listImgs"
          :key="index"
        >
          <img class="img" :src="img" />
        </van-grid-item>
      </van-grid>
      <div class="news-cell-title">{{ processedTitle }}</div>
    </div>
    <div class="news-cell-foot">
      <div class="news-cell-foot-left">
        <div>
          <span class="text">{{ item.source }}</span>
          <span class="text"> {{ dateDiff }}</span>
        </div>
        <span class="right_text">{{ item.hits }}</span>
      </div>
    </div>
  </div>
  <van-divider class="news-cell-divide" />
</template>

<script>
import { Tag, Divider, Icon, Grid, GridItem } from "vant";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import useDateDiff from "@/composiables/useDateDiff.js";
import "../plugins/bridge.js";
export default {
  name: "PicturesCell",
  components: {
    [Tag.name]: Tag,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
  },
  props: {
    item: Object,
  },
  setup(props) {
    const store = useStore();
    const dateDiff = ref(useDateDiff(props.item.publishTime));
    const onClick = (item) => {
      const userAgentString = navigator.userAgent.toLocaleLowerCase();
      if (item.url) {
        if (userAgentString.indexOf("zsrbapp") < 0) {
          // window.location.href = item.url;
          window.open(item.url, "_blank");
        } else {
          store
            .dispatch("getViewInfoBridging", {
              id: item.id,
            })
            .then((res) => {
              window.ZsrbApp.call("viewInfo", res);
            });
        }
      }
    };
    const processedTitle = computed(() => {
      return props.item.title
        .replace(/&nbsp;|\u00A0/g, " ")
        .replace(/\s{2,}/g, " ")
        .trim();
    });
    return {
      dateDiff,
      onClick,
      processedTitle,
    };
  },
};
</script>

<style lang="scss" scoped>
.news-cell {
  padding: 10px 20px;
}
.news-cell-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.news-cell-title {
  text-align: left;
  margin-right: 10px;
  font-size: 16px;
  color: #232323;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-wrap: break-word;
  line-height: 1.5;
}
.news-cell-imgs {
  width: 100%;
  margin: 10px -5px 5px -5px;
}
:deep(.van-grid-item):last-child {
  padding-right: 0 !important;
}
.news-cell-img {
  --van-grid-item-content-padding: 0;
  .img {
    border-radius: 4px;
    width: 100%;
    height: auto;
  }
}

.news-cell-foot {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.news-cell-foot-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .tag {
    padding: 1px 4px 0 4px;
    margin-right: 18px;
    font-size: 12px;
  }
  .right_text {
    font-size: 12px;
    color: #c0c4cc;
  }
  .text {
    margin-right: 14px;
    font-size: 12px;
    color: #c0c4cc;
  }
  .icon {
    width: var(--van-tag-line-height);
    height: var(--van-tag-line-height);
    margin-right: 5px;
  }
}
.news-cell-foot-right {
  display: flex;
  align-items: center;
  .icon {
    width: var(--van-tag-line-height);
    height: var(--van-tag-line-height);
    margin-right: 5px;
  }
  .text {
    color: rgb(252, 36, 42);
    font-size: 12px;
  }
}
.news-cell-divide {
  --van-divider-margin: 0;
  margin: 0 20px;
}
</style>
